
    import './styles.scoped.css';
    export default {
  "header-link-text": "awsui_header-link-text_eymn4_rug8v_5",
  "link-text": "awsui_link-text_eymn4_rug8v_6"
};
  